import R from "ramda";
import {
  FOCUS_DOCUMENT,
  SAVE_DOCUMENT,
  UNFOCUS_DOCUMENT,
  UPDATE_DOCUMENT_INLINE,
  UPDATE_DOCUMENT,
  UPDATE_PAYMENT_TYPE
} from "actions/update-document-actions";

export const initialState = {
  attachment: null,
  categories: [],
  currency: "",
  downloadUrl: "",
  issued: "",
  id: null,
  invoiceNumber: "",
  name: "",
  notes: "",
  paymentType: { type: "other" },
  processingState: "PROCESSED",
  shareUrl: "",
  style: null,
  tax: 0,
  total: 0,
  type: "",
  vendor: ""
};

export const updateDocumentReducer = (state = initialState, action) => {
  switch (action.type) {
    case FOCUS_DOCUMENT:
      return stateForFocusDocument(state, action);
    case UPDATE_PAYMENT_TYPE:
      return stateForUpdatePaymentType(state, action);
    case UPDATE_DOCUMENT:
    case UPDATE_DOCUMENT_INLINE:
      return R.merge(state, { [action.data.field]: action.data.value });
    case UNFOCUS_DOCUMENT:
    case SAVE_DOCUMENT:
      return initialState;
    default:
      return state;
  }
};

const stateForFocusDocument = (state, action) => {
  const document = R.merge(initialState, action.data.row);
  return R.merge(document, { style: action.data.style });
};

const stateForUpdatePaymentType = (state, action) => {
  const newPaymentType = R.set(R.lensProp(action.data.field), action.data.value, state.paymentType);
  return R.merge(state, { paymentType: newPaymentType });
};



// WEBPACK FOOTER //
// ./src/js/reducers/update-document-reducer.js